angular.module('services.newman.WidgetsService', [
  'global'
])

/**
 * The WidgetsService service stores methods used to
 * handle data for widgets
 *
 * @class WidgetsService
 * @constructor
 * @module services.newman.WidgetsService
 */
.factory('WidgetsService', [
  '$q',
  'ModelsService',
  'CasesService',
  'StatesService',
  function ($q, ModelsService, CasesService, StatesService) {
    'use strict';

    var service = {

      widgets: [],

      /**
       * Returns widgets.  If a widgetId is
       * provided will return a single case.  If no
       * widgetId is provided will return all widgets.
       *
       * @param {string} [widgetId] - return only a specific case
       * @param {boolean} [format=false] - flag to format content
       * @return {Object|Array<Object>} All entries
       */
      get: function get(widgetId, format) {
        var ret;

        service.widgets = ModelsService.read('widgets');

        if (widgetId) {
          ret = ModelsService.find('widgets', 'id', widgetId);
        } else {
          ret = service.widgets;
        }

        if (format) {
          ret = {
            label: ret.label,
            content: ret.content
          };
        }

        return ret;
      },

      /**
       * Returns resolved objects from a list of IDs
       *
       * @param {Array<string>} list - Array of widget IDs
       * @return {Array<Object>} Collection of widget objects
       */
      getFromList: function getFromList(list) {
        var widgets = [];

        _.forEach(list, function (obj) {
          var widget = ModelsService.find('widgets', 'id', obj.id);
          widgets.push(widget);
        });

        return widgets;
      },

      /**
       * Creates a new widget from provided data
       *
       * @param {string} model - State model
       * @param {Object} scope - Angular $scope
       * @return {Promise<Object>} New widget
       */
      create: function create(model, scope) {
        var widget = {
          label: model.label,
          content: model.content
        };
        var endpoint = ModelsService.find('endpoints', 'label', 'widgets');

        console.log('WidgetsService: create: model', model);
        console.log('WidgetsService: create: widget', widget);

        return ModelsService
          .create(endpoint, widget)
          .then(function (response) {
            return $q.all([
              CasesService.addRelative(scope.cases.current, response),
              StatesService.addWidget(scope.states.current, response)
            ]);
          })
          .catch(function (response) {
            console.log(response);
          });
      },

      /**
       * Updates an existing widget from provided data
       *
       * @param {string} model - State model
       * @param {Object} scope - Angular $scope
       * @return {Promise<Object>} Updated widget
       */
      update: function update(model, scope) {
        var widget = {
          label: model.label,
          content: model.content
        };

        var endpoint = ModelsService.find('widgets', 'id', model.id);

        return ModelsService
          .update(endpoint, widget)
          .then(function (response) {
            CasesService.addRelative(scope.cases.current, response);
            return response;
          })
          .catch(function (response) {
            console.log(response);
          });
      },

      /**
       * Adds a relative instance based on
       * provided data
       *
       * @param {Array<Object>} relatives - Array of existing relatives
       * @param {Object} data - Data for new relative
       * @return {Array<Object>} Updated array of relatives
       */
      addRelative: function addRelative(relatives, data) {
        var relative = {};

        relative.id = data.id;
        relative.label = data.label;
        relative.model = data.model;
        relative.href = 'http://localhost:4242/api/v1/' + data.model + '/' + data.id;
        relative.classes = [data.model];

        relatives.push(relative);

        return relatives;
      },

      /**
       * Populate a UI friendly model from pristine
       * state data
       *
       * @param {Object} model - Model template
       * @param {Object} data - Pristine data
       * @return {Object} Model after population of data
       */
      populateModel: function populateModel(model, data) {
        model.label = data.label;
        model.content = data.content;
        return model;
      },

      /**
       * Returns a list of widgets found inside of an item's
       * relatives collection
       *
       * @param {Array<Object>} relatives - Relatives collection
       * @return {Array<Object>} Collection of widgets
       */
      getWidgetsFromRelatives: function getWidgetsFromRelatives(relatives) {
        var widgetList = [];

        widgetList = _.filter(relatives, function (obj) {
          return _.includes(obj.classes, 'widgets');
        });

        return widgetList;
      }

    };

    return service;
  }
]);
